module.exports = __webpack_public_path__ + "img/reviewExperimentFailed.83e7b4be.svg";